/* Do2Nite — mobile menu helpers (global)
   1. Toggles body.d2n-menu-open while the drawer is open (used to hide
      the sticky-nav on the home calendar).
   2. Renames the drawer's "Account" link to "My Do2Nite".
   3. Redirects logged-in customers off /account* to /pages/my-do2nite so
      they don't see the generic Shopify hosted account UI.             */
(function () {
  'use strict';

  /* ── /account → /pages/my-do2nite redirect ────────────────────────────
     Only fires on do2nite.com /account paths; doesn't touch shopify.com
     hosted pages (out of our scope). The Liquid wrapping reads
     `customer` so we know if someone is logged in.                      */
  var IS_LOGGED_IN = (window.D2N_LOGGED_IN === true);
  var path = (window.location.pathname || '');
  if (IS_LOGGED_IN && /^\/account(\/|$)/.test(path)) {
    window.location.replace('/pages/my-do2nite');
    return;
  }

  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'DETAILS') return;
    var isMenu = !!(t.closest && t.closest('header-drawer')) ||
                 t.id === 'Details-menu-drawer-container';
    if (!isMenu) return;
    document.body.classList.toggle('d2n-menu-open', t.open);
  }, true);

  function renameAccount() {
    var links = document.querySelectorAll('#menu-drawer a, .menu-drawer a');
    links.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/account') === 0 && a.textContent.trim() === 'Account') {
        a.textContent = 'My Do2Nite';
      }
    });
  }

  function init() {
    renameAccount();
    setTimeout(renameAccount, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
